import { render } from "./PagerHeader.vue?vue&type=template&id=4f8d8025&scoped=true"
import script from "./PagerHeader.vue?vue&type=script&lang=js"
export * from "./PagerHeader.vue?vue&type=script&lang=js"

import "./PagerHeader.vue?vue&type=style&index=0&id=4f8d8025&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8d8025"]])

export default __exports__